/**
 * Core Input Component
 * Wraps MUI TextField for consistent styling and theme integration.
 */
import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

export interface InputProps {
  label?: string;
  id?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  required?: boolean;
  name?: string;
  autoComplete?: string;
  multiline?: boolean;
  rows?: number;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const Input = React.forwardRef<HTMLDivElement, InputProps>(
  ({ label, leftIcon, rightIcon, readOnly, size = 'small', fullWidth = true, className = '', ...props }, ref) => {
    return (
      <TextField
        ref={ref}
        label={label}
        variant="outlined"
        size={size}
        fullWidth={fullWidth}
        disabled={readOnly}
        className={className}
        InputProps={{
          readOnly,
          ...(leftIcon ? {
            startAdornment: <InputAdornment position="start">{leftIcon}</InputAdornment>,
          } : {}),
          ...(rightIcon ? {
            endAdornment: <InputAdornment position="end">{rightIcon}</InputAdornment>,
          } : {}),
        }}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';
export default Input;
